import { render, staticRenderFns } from "./UploadConsumerDocument.vue?vue&type=template&id=16702104&scoped=true&"
import script from "./UploadConsumerDocument.vue?vue&type=script&lang=js&"
export * from "./UploadConsumerDocument.vue?vue&type=script&lang=js&"
import style0 from "./UploadConsumerDocument.vue?vue&type=style&index=0&id=16702104&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16702104",
  null
  
)

export default component.exports